import * as React from 'react'

export type FiltersType = {
    id: string
    isSelected: boolean
    name: React.ReactNode
}

export type UpdateFilterType = (tagName: string, isSelected: boolean) => void

type UseTagListFilter = {
    controlledFilters: FiltersType[]
    updateFilter: UpdateFilterType
}

export function useFilterList(filters: FiltersType[]): UseTagListFilter {
    const [controlledFilters, setControlledFilters] = React.useState(filters)

    function updateFilter(filterId: string, isSelected: boolean) {
        const updatedTags = controlledFilters.map(currentFilter => {
            if (currentFilter.id === filterId) {
                return {
                    ...currentFilter,
                    isSelected: isSelected
                }
            } else {
                return currentFilter
            }
        })

        setControlledFilters(updatedTags)
    }

    return { controlledFilters, updateFilter }
}
